import React from "react";
import styled from "styled-components";

export default function FullButton({ title, action, link, border }) {
  if (link) {
    return (
      <AWrapper
        className="animate pointer radius8"
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        border={border}
      >
        {title}
      </AWrapper>
    );
  }

  return (
    <Wrapper
      className="animate pointer radius8"
      onClick={action ? () => action() : null}
      border={border}
    >
      {title}
    </Wrapper>
  );
}

const buttonStyles = `
  border: 1px solid #7620ff;
  background-color: #7620ff;
  width: 100%;
  padding: 15px;
  outline: none;
  color: #fff;
  text-align: center;
  text-decoration: none;
  display: inline-block;

  &:hover {
    background-color: #580cd2;
    border: 1px solid #7620ff;
    color: #fff;
  }
`;

const Wrapper = styled.button`
  ${(props) =>
    props.border
      ? `
    border: 1px solid #707070;
    background-color: transparent;
    color: #707070;

    &:hover {
      background-color: transparent;
      border: 1px solid #7620ff;
      color: #7620ff;
    }
  `
      : buttonStyles}
  width: 100%;
  padding: 15px;
  outline: none;
  border-radius: 8px;
`;

const AWrapper = styled.a`
  ${(props) =>
    props.border
      ? `
    border: 1px solid #707070;
    background-color: transparent;
    color: #707070;

    &:hover {
      background-color: transparent;
      border: 1px solid #7620ff;
      color: #7620ff;
    }
  `
      : buttonStyles}
  border-radius: 8px;
`;
